import sleep from "./sleep";

export const toastDuration = 3000;

// wait for react to update state
export const waitReactUpdate = async () => await sleep(0);
